import { useState } from 'react';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from '../tooltip/Tooltip';
import classes from './SelectableTooltip.module.scss';

const SelectableTooltip = ({ children, title }) => {
  const [show, setShow] = useState(false);

  const handleEnter = () => setShow(true);
  const handleExit = () => setShow(false);

  return (
    <div
      onMouseEnter={handleEnter}
      onMouseLeave={handleExit}
      className='d-inline-block'>
      <OverlayTrigger
        delay={{ show: 800, hide: 0 }}
        show={show}
        placement='top'
        overlay={
          <Tooltip className='gne-tooltip'>
            <div style={{ userSelect: 'text' }}>{title}</div>
          </Tooltip>
        }>
        <div className={classes['content-wrapper']}>
          <span>{children}</span>
        </div>
      </OverlayTrigger>
    </div>
  );
};

export default SelectableTooltip;
